import styled from 'styled-components';

export const ClearSearch = styled.span`
  cursor: pointer;
`;

export const Container = styled.div`
  width: 300px;
`;
